import { NoImage } from "@assets/constant/index.constant";
import { Badge } from "@components/ui/badge";
import { endpoint } from "@services/api.services";
import { ZoomImage } from "@ui/internal/components/formelement";
import { useHandleAction } from "@utils/hook/index.hook";
import { useMemo } from "react";
import Tooltip from "@ui/external/components/tooltip";
import { useSelectionStore } from "@utils/states/index.state";
interface CloumnListProps {
  refetch?: () => void;
}
const ColumnList = ({ refetch }: CloumnListProps) => {
  const journeyEndpoint = useMemo(() => endpoint["journey"], []);
  const { clearSelection } = useSelectionStore();
  const { handleAction } = useHandleAction({
    endpoint: journeyEndpoint,
    refetch,
  });
  const columns = useMemo(
    () => [
      {
        name: "ID",
        accessKey: "id",
        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row?.id}</span>
        ),
        sortable: true,
      },
      {
        name: (
          <span className="flex items-center gap-2">
            <span className="lg:block hidden">Featured</span> Image
          </span>
        ),
        accessKey: "image",

        cell: (row: any) => (
          <>
            <ZoomImage>
              <div className="border rounded-md hover:outline-[#1aa178]/50 hover:outline-2 overflow-hiddenbg-slate-100">
                <img
                  src={row?.image || NoImage}
                  alt="Cropped"
                  onError={(e: any) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    target.src = NoImage;
                  }}
                  className="object-cover h-[80px] max-md:h-[40px] max-md:w-[40px] w-[200px] border rounded-md"
                />
              </div>
            </ZoomImage>
          </>
        ),
        sortable: false,
      },
      {
        name: "Section",
        cell: (row: any) => (
          <Badge
            variant={"secondary"}
            className="w-[60px] text-[#f0af1d] capitalize"
          >
            {row.section}
          </Badge>
        ),
        sortable: true,
      },
      {
        name: "Title",
        accessKey: "title",
        cell: (row: any) => (
          <Tooltip description={row.title}>
            <div className="flex justify-start text-gray-800">
              <span className="text-start w-fit max-w-[150px] truncate">
                {row.title}
              </span>
            </div>
          </Tooltip>
        ),
        sortable: true,
      },
      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <button
              className="text-[#1DA077] cursor-pointer"
              onClick={() => handleAction({ type: "modal-edit", data: row.id })}
              title="Edit"
            >
              Edit
            </button>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );

  return columns;
};

export { ColumnList };
